import * as React from "react";
import MultiBrandUtilityBar from "../MultiBrandUtilityBar";
import styled from "styled-components";
import {
  WideWrapper,
  WRAPPER_MOBILE_MAX_WIDTH,
  WRAPPER_WIDE_MAX_WIDTH,
} from "../../../styles/shared/layout";
import {
  brandBlueDark,
  darkGreyV2,
  white,
  brandBlueLight,
} from "../../../styles/shared/colors";
import { Link, navigate } from "gatsby";
import { useLocation } from "@reach/router";
import HamburgerColor from "../../../assets/icon-colors/mutibrand-icons/icon-hamburger-color.svg";
import HamburgerWhite from "../../../assets/icon-colors/mutibrand-icons/icon-hamburger-white.svg";
import CloseWhite from "../../../assets/icon-colors/mutibrand-icons/icon-close-white.svg";
import MultiBrandNav from "./MultiBrandNav";
import { breakpoints } from "../../../styles/shared/breakpoints";
import useWindowSize from "../../../util/hooks/useWindowSize";
import multiHeaderCopy from "./copy/header";
import DownArrow from "../../../assets/images/franchise/dropdownicon.svg";
import DownArrowHover from "../../../assets/images/franchise/dropdownicon-hover.svg";
import RightArrow from "../../../assets/images/franchise/right-arrow.svg";
import DownArrowActive from "../../../assets/images/franchise/dropdownicon-active.svg";
import DoubleBarActive from "../../../assets/images/franchise/doublebar-active.png";
import Helmet from 'react-helmet';

const MultiBrandHeaderMain = styled.header`
  position: sticky;
  top: 0;
  z-index: 5;
  width: 100%;
`;

export default function MultiBrandHeader({ pageKey }) {
  const headerData = multiHeaderCopy[pageKey];

  return (
    <MultiBrandHeaderMain>
      <MultiBrandUtilityBar />
      <MultiBrandHeaderWithNav
        pageKey={pageKey}
        className={headerData.className}
        bgImg={headerData.bgImg}
        bgImgMob={headerData.bgImgMob}
        bgImgTab={headerData.bgImgTab}
        logosData={headerData.logos}
        showPrimaryNav={headerData.showPrimaryNav}
      />
    </MultiBrandHeaderMain>
  );
}
const MultiBrandWideWrapper = styled(WideWrapper)`
  @media (min-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
    padding: 0 20px;
  }
`;
const MultiBrandHeaderOuterWrapper = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  background-image: url(${(props) => (props.bgImg ? props.bgImg : "")});
  background-color: ${white};
  // background-size: ${(props) =>
  props.spaceLogo
    ? `calc(min(100vw, 1440px) - ${props.spaceLogo})`
    : "100%"} 100%;
   background-size: calc(min(100vw, 1440px) - var(--logo-space) + 20px) 100%;
  background-repeat: no-repeat;
   // background-position: ${(props) => (props.spaceLogo ? `${Math.floor(Number(props.spaceLogo.replace("px",""))) - 20}px` : "center")} center;
  background-position: calc(var(--logo-space) - 15px) center;
  // border-bottom: 2px solid ${brandBlueDark};
  transition:
    transform 200ms ease-in-out,
    background-color 200ms ease-in-out;

  &::after {
    content: "";
    position: absolute;
    bottom: 0; /* exact edge */
    left: 0;
    width: 100%;
    height: 1px;
    background: ${brandBlueDark};
    z-index: 1;
  }

  @media (max-width: ${breakpoints.md}px) {
    padding: 0 20px;
  }
  @media (max-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
    background-image: unset;
    padding: 0 12px;
    background-color: ${(props) => (props.openMenu ? white : brandBlueDark)};
    &.home-welireg-header {
      background-image: url(${(props) => (props.bgImg ? props.bgImg : "")});
      background-size: cover;
      // background-position: 21% 50%;
      .header-hamburger-menu {
        color: ${white};
        .icon-hamburger {
          background-image: url(${HamburgerWhite}) !important;
        }
      }
    }
  }
  // @media (min-width: 1550px) {
  //   &.home-welireg-header {
  //     background-size: 87% 100%;
  //     background-position: right center;
  //   }
  // }
`;
const MultiBrandHeaderWrapper = styled.div`
  width: 100%;
  min-height: 96px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: ${WRAPPER_MOBILE_MAX_WIDTH}) {
    gap: 12px;
  }
`;

const MultiBrandLogoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  a{
  cursor: auto;
  }
  ${(props) =>
    !props.isLogoOne
      ? `
             a{
            padding-right 13px;
        }
        a:last-child{
            padding-left: 13px;
            padding-right: 0px;
            border-left: 1px solid ${darkGreyV2};
        }
            @media(max-width: ${breakpoints.mid}px){
            a{
                padding-right 9px;
            }
            a:last-child{
                padding-left: 9px;
                padding-right: 0px;
            }
        }
            `
      : ``}

  .keytruda-welireg-logo {
    // min-width: 165px;
    // max-width: 227px;
    width: 165px;
    width: clamp(165px, 30vw, 227px);
  }
  .keytruda-qlex-logo {
    // min-width: 137px;
    // max-width: 189px;
    width: 137px;
    width: clamp(322px, 35vw, 443px) !important;
  }
`;

const MultiBrandNavlinksWrapper = styled.div`
  display: flex;
  height: 96px;
  max-width: 440px;
  min-height: 96px;
  align-items: flex-end;
  gap: 1px;
  margin-left: 4px;

  @media (max-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
    display: none;
  }
`;

const MultiBrandHamburgerMenuBtn = styled.button`
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  font-family: "proxima-nova";
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 1;
  padding: 0;
  text-transform: uppercase;
  cursor: pointer;
  .icon-hamburger {
    width: 23px;
    height: 18px;
    background-image: url(${HamburgerColor});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
  .icon-close {
    width: 18px;
    height: 18px;
    background-image: url(${CloseWhite});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
  @media (max-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
    display: flex;
    color: ${white};
    .icon-hamburger {
      background-image: url(${HamburgerWhite});
    }
  }

  @media (max-width: ${WRAPPER_WIDE_MAX_WIDTH}) {
    .icon-hamburger {
      background-image: ${(props) =>
        props.useWhiteHamburger
          ? `url(${HamburgerWhite})`
          : `url(${HamburgerColor})`};
    }

    color: ${(props) =>
      props.useWhiteHamburger
        ? white
        : props.openMenu
        ? brandBlueDark
        : white};
  }
`;

const MultiBrandNavContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  // margin-top: 2px;
  height: 100vh;
  background: ${white};
  transition: transform 0.5s ease-in-out;
  transform: translateX(${(props) => (props.openMenu ? "100%" : "0")});
`;

const StyledNavItem = styled.div`
  cursor: pointer;
  color: rgb(255, 255, 255);
  position: relative;
  text-align: center;
  display: flex;
  height: 96px;
  min-height: 96px;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  padding: 12px 9px;

  &:hover {
    // background: linear-gradient(180deg, #d9e7f4 0%, #fff 41.38%), #fff;
    background: ${brandBlueLight};
  }

  &:hover .NavLabelText {
    // color: ${brandBlueDark};
    color: ${white}
  }

  ${({ isActive }) =>
    isActive &&
    `
      background: linear-gradient(180deg, #d9e7f4 0%, #fff 41.38%), #fff;

      .NavLabelText {
        color: ${brandBlueDark};
      }

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background-image: url(${DoubleBarActive});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        z-index: 3;
      }
  `}
  &:hover::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: ${brandBlueLight};
    z-index: 2;
  }
`;

const NavLabel = styled(Link)`
  display: flex;
  min-width: 50px;
  max-width: 193px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  height: 69px;
  text-decoration: none;
`;

const NavLabelText = styled.span`
  color: ${white};
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  // white-space: nowrap;
  font-size: 15px;
  font-weight: 700;
  line-height: 18px;
  display: flex;
  height: 53px;
  flex-direction: column;
  justify-content: flex-end;
  flex-shrink: 0;
  align-self: stretch;

  &:hover {
  }
`;

const DropdownIcon = styled.img`
  width: 10px;
  height: 6px;
  transition: transform 0.3s ease, filter 0.3s ease;

  ${({ isHovered }) =>
    isHovered &&
    `
      filter: brightness(0) invert(1);
      transform: rotate(180deg);
  `}
`;

const ChildArrow = styled.img`
  width: 18px;
  height: 20px;
  transition: transform 0.3s ease;
`;

const DropDownLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 8px 8px;
  flex-wrap: wrap;
`;

const DropdownLink = styled(Link)`
  display: flex;
  min-height: 20px;
  padding-right: 28px;
  align-items: center;
  gap: 16px;
  color: ${brandBlueDark};
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  text-decoration: none;

  &:hover {
    line-height: 19px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-color: #3f89c8;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }

  &:focus-visible {
    box-shadow: 0 0 24px 0 #83d2ff;
    line-height: 19;
  }
`;

const DropdownWrapper = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: ${white};
  z-index: 10;
  box-shadow: 0 10px 20px 0 #d9e7f4;
`;

const DropdownInner = styled.div`
  display: flex;
  width: 1440px;
  height: 51px;
  padding: 15px 30px;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 12px 10px;
  flex-wrap: wrap;
`;

function MultiBrandHeaderWithNav({
  pageKey,
  bgImg,
  bgImgMob,
  bgImgTab,
  logosData,
  className,
  showPrimaryNav,
}) {
  const [activeNav, setActiveNav] = React.useState(null);
  const [openMenu, setOpenMenu] = React.useState(true);
  const [scrollPos, setScrollPos] = React.useState(0);
  const [hoveredNav, setHoveredNav] = React.useState(null);
  const [mobileView, setMobileView] = React.useState("main");
  const [selectedNav, setSelectedNav] = React.useState(null);
 // const [spaceLogo, setSpaceLogo] =  React.useState("0px");

  const headerRef = React.useRef(null);
  const logoWrapper = React.useRef(null);
  const { width } = useWindowSize();
  const location = useLocation();

  // React.useEffect(()=>{
  //   function handleLogoSize(){
  //     const logoWrapperEle = logoWrapper.current;
  //     if(!logoWrapper) return;

  //     const getWidth = logoWrapperEle.getBoundingClientRect().width;
  //     const containerWidth = width > 1024 ? width > 1440 ? Math.floor((1440 - 984) / 2) : Math.floor((window.innerWidth - 984) / 2) : 20;

  //     if(getWidth){
  //       setSpaceLogo(containerWidth + getWidth + "px")
  //     }
  //   }
  //   handleLogoSize();
  // },[width])

  React.useEffect(() => {
  const el = logoWrapper.current;
  if (!el) return;

  const observer = new ResizeObserver(() => {
    const eleMentWidth = el.getBoundingClientRect().width;
     const containerWidth = width > 1024 ? width > 1440 ? Math.floor((1440 - 984) / 2) : Math.floor((window.innerWidth - 984) / 2) : 20;


    document.documentElement.style.setProperty(
      "--logo-space",
      `${Math.floor(eleMentWidth + containerWidth)}px`
    );
  });

  observer.observe(el);

  return () => observer.disconnect();
}, [width]);

  const headerData = multiHeaderCopy[pageKey] || {};
  const useWhiteHamburger = headerData.useWhiteHamburger;
  const navItems = headerData.navItems || [];

  function handleScroll() {
    const scrollStart = 320;
    const currentScroll = window.scrollY;

    if (currentScroll > scrollPos && currentScroll > scrollStart) {
      headerRef.current.style.transform = "translateY(-100%)";
    } else {
      headerRef.current.style.transform = "translateY(0)";
    }

    setScrollPos(currentScroll);
  }

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollPos]);



  const isNavActive = (pathname, navPath) => {
    if (!pathname || !navPath) return false;

    const normalize = (path) =>
      path.toLowerCase().replace(/\/+$/, "").split("?")[0].split("#")[0];

    const current = normalize(pathname);
    const nav = normalize(navPath);

    return current === nav || current.startsWith(nav + "/");
  };

  React.useEffect(() => {
  if (!location.hash) return;

  const id = location.hash.replace("#", "");

  window.scrollTo(0, 0);

  const scrollToSection = () => {
    const el = document.getElementById(id);

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      return true;
    }

    return false;
  };

  // wait for render
  const timer = setTimeout(() => {
    scrollToSection();
  }, 300);

  return () => clearTimeout(timer);

}, [location.pathname, location.hash]);

  // console.log("PATHNAME:", location.pathname);
  // console.log("NAV ITEMS:", navItems);

  return (
     <>
     {!openMenu && (
        <Helmet>
          <html className="no-scroll" />
          {/* <body className="no-scroll" /> */}
        </Helmet>
      )}
    <MultiBrandHeaderOuterWrapper
      ref={headerRef}
      bgImg={bgImg}
      bgImgMob={bgImgMob}
      bgImgTab={bgImgTab}
      openMenu={openMenu}
      className={className}
      //spaceLogo={spaceLogo}
      //windowWidth={width}
    >
      <MultiBrandWideWrapper>
        <MultiBrandHeaderWrapper>
          <MultiBrandLogoWrapper ref={logoWrapper} isLogoOne={logosData.length === 1}>
            {logosData.map((logo, i) => (
              <Link to={logo.link} key={i}>
                <img
                  src={
                    width >= 1025
                      ? logo.path
                      : openMenu
                        ? logo.path
                        : logo.pathMobileMenuOpened || logo.path
                  }
                  alt={logo.alt}
                  className={logo.className}
                />
              </Link>
            ))}
          </MultiBrandLogoWrapper>
          {width >= 1025 && showPrimaryNav && (
            <MultiBrandNavlinksWrapper onMouseLeave={() => setActiveNav(null)}>
              {navItems.map((item) => {
                const active = isNavActive(location.pathname, item.path);
                const isHovered = hoveredNav === item.label;

                return (
                  <StyledNavItem
                    key={item.label}
                    onMouseEnter={() => {
                      setActiveNav(item.label);
                      setHoveredNav(item.label);
                    }}
                    onMouseLeave={() => setHoveredNav(null)}
                    isActive={active}
                  >
                    <NavLabel to={item.path}>
                      <NavLabelText className="NavLabelText">
                        {item.label}
                      </NavLabelText>

                      <DropdownIcon
                        src={
                          isHovered
                            ? DownArrow //hover → normal icon
                            : active
                              ? DownArrowActive //active → active icon
                              : DownArrow
                        }
                        isHovered={isHovered} //rotate only on hover
                      />
                    </NavLabel>
                  </StyledNavItem>
                );
              })}

              {activeNav && (
                <DropdownWrapper onMouseLeave={() => setActiveNav(null)}>
                  <DropdownInner>
                    {navItems
                      .find((n) => n.label === activeNav)
                      ?.anchors.map((link) => (
                        <DropDownLinkWrapper>
                          <DropdownLink
                            key={link.id}
                            to={`${navItems.find((n) => n.label === activeNav).path}#${link.id}`}
                            onClick={(e) => {
                              e.preventDefault();

                              const activeItem = navItems.find((n) => n.label === activeNav);
                              const targetPath = activeItem.path;
                              const currentPath = window.location.pathname;

                              const normalize = (path) => path.replace(/\/+$/, "");

                              if (normalize(currentPath) === normalize(targetPath)) {
                                const target = document.getElementById(link.id);

                                if (target) {
                                  target.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start",
                                  });

                                  window.history.replaceState(
                                    null,
                                    "",
                                    `${targetPath}#${link.id}`
                                  );
                                }
                              }

                              else {
                                navigate(`${targetPath}#${link.id}`);
                              }

                              setActiveNav(null);
                            }}
                          >
                            {link.label}
                            <ChildArrow src={RightArrow} />
                          </DropdownLink>
                        </DropDownLinkWrapper>
                      ))}
                  </DropdownInner>
                </DropdownWrapper>
              )}
            </MultiBrandNavlinksWrapper>
          )}

          <MultiBrandHamburgerMenuBtn
            aria-expanded={!openMenu}
            aria-label="Toggle menu"
            openMenu={openMenu}
             useWhiteHamburger={useWhiteHamburger}
            onClick={() => {
              setOpenMenu(!openMenu);
              setMobileView("main");
            }}
          >
            {openMenu ? (
              <>
                <i className="icon-hamburger" />
                Menu
              </>
            ) : (
              <>
                <i className="icon-close" />
                Close
              </>
            )}
          </MultiBrandHamburgerMenuBtn>
        </MultiBrandHeaderWrapper>
      </MultiBrandWideWrapper>

      <MultiBrandNavContainer
        openMenu={openMenu}
        inert={openMenu ? "" : undefined}
      >
        <MultiBrandNav
          type="main"
          navItems={navItems}
          mobileView={mobileView}
          setMobileView={setMobileView}
          selectedNav={selectedNav}
          setSelectedNav={setSelectedNav}
          setOpenMenu={setOpenMenu}
        />
      </MultiBrandNavContainer>
    </MultiBrandHeaderOuterWrapper>
    </>
  );
}
 